// Библиотека сервиса AIAgent: определение типа сообщений чата и подготовка их текста к показу (используется компонентами AIAgent.*.vue)
export const AIAgentMessages = {

	Name: "AI Chat Messages",

	// Тип сообщения: 'tool' - вызов инструмента агентом, 'stats' - статистика работы, 'voice' - распознанное голосовое сообщение, 'asset-created' - ассет, созданный агентом, 'error' - ошибка, 'text' - обычное сообщение
	getMessageType(message) {

		if (message.options?.type) return message.options.type;
		if (message.options?.error) return 'error';

		return 'text';

	},

	// HTML текста сообщения: сначала экранируем весь текст (чтобы модель не могла вставить свою разметку),
	// затем заменяем выделение модели **текст** на элемент-обёртку strong.ai-chat-highlight,
	// строки ### Заголовок - на заголовок, markdown-таблицы - на table, строки > цитата - на блок цитаты, строки --- - на разделитель,
	// а HTML-сущности (&rarr; &mdash; &#8594; и т.п.) - на соответствующие символы. Блоки вставляются без переводов строк вокруг, так как у текста white-space: pre-wrap
	formatMessageText(text) {

		let escaped = String(text || '')
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');

		// Строчное форматирование: HTML-сущности, экранированные выше, возвращаем (сущность - это только символ, разметку через неё вставить нельзя),
		// затем выделение **текст**
		let highlight = line => line
			.replace(/&amp;([a-zA-Z][a-zA-Z0-9]{1,31}|#[0-9]{1,7}|#x[0-9a-fA-F]{1,6});/g, '&$1;')
			.replace(/\*\*(?!\s)([^\n]+?)(?<!\s)\*\*/g, '<strong class="ai-chat-highlight">$1</strong>');

		// Строка цитаты (> текст, символ > уже экранирован) и разделитель (---, *** или ___)
		let quotePattern = /^\s{0,3}&gt;\s?/,
			isSeparator = line => /^\s{0,3}([-*_])(\s*\1){2,}\s*$/.test(line);

		let isTableRow = line => /^\s*\|.*\|\s*$/.test(line),
			isTableSeparator = line => /^\s*\|(\s*:?-+:?\s*\|)+\s*$/.test(line),
			splitCells = line => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(cell => cell.trim());

		let lines = escaped.split('\n'),
			parts = [],
			textLines = [];

		let flushText = () => {

			if (textLines.length) parts.push(highlight(textLines.join('\n')));

			textLines = [];

		};

		for (let i = 0; i < lines.length; i++) {

			let line = lines[i],
				heading = line.match(/^\s{0,3}(#{1,6})\s+(.+?)\s*#*\s*$/);

			if (heading) {

				flushText();

				parts.push(`<div class="ai-chat-heading level-${heading[1].length}">${highlight(heading[2])}</div>`);

			} else if (isTableRow(line) && i + 1 < lines.length && isTableSeparator(lines[i + 1])) {

				flushText();

				let aligns = splitCells(lines[i + 1]).map(cell => cell.startsWith(':') && cell.endsWith(':') ? 'center' : cell.endsWith(':') ? 'right' : 'left'),
					cellHtml = (tag, cell, index) => `<${tag} style="text-align: ${aligns[index] || 'left'}">${highlight(cell)}</${tag}>`,
					headHtml = splitCells(line).map((cell, index) => cellHtml('th', cell, index)).join(''),
					rowsHtml = '';

				i += 2;

				for (; i < lines.length && isTableRow(lines[i]); i++) rowsHtml += '<tr>' + splitCells(lines[i]).map((cell, index) => cellHtml('td', cell, index)).join('') + '</tr>';

				i--;

				parts.push(`<table class="ai-chat-table"><thead><tr>${headHtml}</tr></thead><tbody>${rowsHtml}</tbody></table>`);

			} else if (quotePattern.test(line)) {

				flushText();

				// Подряд идущие строки цитаты объединяем в один блок
				let quoteLines = [];

				for (; i < lines.length && quotePattern.test(lines[i]); i++) quoteLines.push(lines[i].replace(quotePattern, ''));

				i--;

				parts.push(`<div class="ai-chat-quote">${highlight(quoteLines.join('\n'))}</div>`);

			} else if (isSeparator(line)) {

				flushText();

				parts.push('<hr class="ai-chat-separator">');

			} else {

				// После блока первая пустая строка текста не нужна, перевод строки уже обеспечен самим блоком
				textLines.push(line);

			}

		}

		flushText();

		return parts.join('');

	},

	// Описание ошибки фрейма превью: текст ошибки и место её возникновения (для показа в чате и для запроса агенту)
	getPreviewErrorDescription(error) {

		let location = error.source ? ` (${error.source}${error.line ? `:${error.line}:${error.column}` : ''})` : '';

		return `${error.message}${location}`;

	}

};
